export default __webpack_public_path__ + "static/media/circleShapePrimaryColor.eb99594e.svg";